<template>
  <v-autocomplete
    no-data-text="Danh sách trống"
    v-bind="this.$attrs"
    item-text="tags"
    item-value="id"
    :items="teachers"
    return-object
    @change="onChange"
    v-on:input="$emit('input', $event)"
    clearable
    :loading="loading"
    v-model="teacher"
    ref="selectForm"
  >
    <template v-slot:item="data">
      <v-list-item-content>
        <CardTeacherInfo
          :displayGender="displayGender"
          :teacher="data.item"
          :displaySubjectGroup="displaySubjectGroup"
          :displayCode="displayCode"
          :displayDob="displayDob"
          :displayStatus="displayStatus"
        />
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
import { Teacher } from '@/plugins/api'
import CardTeacherInfo from '@/components/basic/card/CardTeacherInfo.vue'

export default {
  components: {
    CardTeacherInfo,
  },
  data: () => ({
    teachers: [],
    loading: false,
    teacher: '',
  }),
  props: {
    filter: Object,
    options: Object,
    defaultTeachers: Object,
    defaultTeacher: Object,
    displayGender: Boolean,
    displaySubjectGroup: Boolean,
    displayCode: Boolean,
    displayDob: { type: Boolean, default: true },
    displayStatus: Boolean,
    syncedValue: Object,
  },
  watch: {
    filter(filter) {
      this.fetchAllTeachers()
    },
    syncedValue: {
      handler(value) {
        this.teacher = value
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    if (this.defaultTeachers) {
      this.teachers = this.defaultTeachers
    }
    this.fetchAllTeachers()
  },
  methods: {
    async fetchAllTeachers() {
      this.loading = true
      let teachers = await Teacher.fetch({
        ...this.filter,
        _sort: 'nameToNumber:ASC,status:ASC',
        _limit: -1,
      })
      if (this.defaultTeacher) {
        teachers = teachers.filter(item => item.id !== this.defaultTeacher.id)
      }
      teachers.forEach(teacher => {
        teacher.tags = [teacher.name, teacher.code].join(' ')
      })
      this.teachers = teachers
      this.loading = false
    },
    onChange(data) {
      this.$emit('update:syncedValue', data)
      this.$emit('change', data)
    },
    validate() {
      return this.$refs.selectForm.validate()
    },
  },
}
</script>
